import * as issueStatuses from "./issueStatuses";
import i18n from "@/common/lang.serivce";
import { NEW } from "./issueStatuses";
import { RESOLVED } from "./issueStatuses";
import { UNCONFIRMED } from "./issueStatuses";
import { IN_VERIFICATION } from "./issueStatuses";
import { CONFIRMED } from "./issueStatuses";
import { IN_PROGRESS } from "./issueStatuses";

const IssueStates = {
  list() {
    return Object.keys(issueStatuses);
  },
  getAll() {
    return this.list().map(issueStatuses => {
      return {
        value: issueStatuses,
        text: i18n.t("issueStatus." + issueStatuses),
        disabled: issueStatuses === NEW || issueStatuses === RESOLVED
      };
    });
  },
  isEditable(status) {
    return status !== RESOLVED && status !== UNCONFIRMED;
  },
  isActive(status) {
    return (
      status === IN_VERIFICATION ||
      status === CONFIRMED ||
      status === IN_PROGRESS
    );
  }
};

export default IssueStates;
